<template>
  <div>
    <div class="container is-light">

      <div class="columns mt-01">
        <div class="column">
          <img :src="error404" alt="Error 404 img"/>
          <div class="has-text-white">Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
          <h3 class="title is-size-1 is-spaced">Upss!</h3>
          <h4 class="title is-size-2 is-spaced">Página no encontrada!</h4>

          <router-link to="/" class="button is-large is-danger">Inicio</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import error404 from '@/assets/img/error404.png'

export default {
  name: 'Error404',
  data () {
    return {
      error404:error404,
    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/errors/Error404.vue